/**
 * OTP Input Component
 * Auto-focus, paste handling, keyboard navigation
 * Validation et désactivation du bouton submit
 *
 * @param {Object} options - Options de configuration
 * @param {boolean} options.autoSubmit - Auto-soumettre le formulaire quand tous les champs sont remplis (défaut: false)
 */

export function initOTPInput(options = {}) {
  const { autoSubmit = false } = options;

  const container = document.querySelector('[data-otp-input]');
  if (!container) return;

  const inputs = container.querySelectorAll('input[data-otp-digit]');
  const hiddenInput = document.querySelector('[data-otp-value]');
  const form = container.closest('form');
  const submitButton = form?.querySelector('button[type="submit"]');

  // Désactiver le bouton au départ
  if (submitButton) {
    submitButton.disabled = true;
  }

  // Auto-remplissage du code depuis l'URL (?code=123456)
  const urlParams = new URLSearchParams(window.location.search);
  const codeFromUrl = urlParams.get('code');

  if (codeFromUrl && /^\d{6}$/.test(codeFromUrl)) {
    // Remplir automatiquement les champs avec le code de l'URL
    codeFromUrl.split('').forEach((digit, index) => {
      if (inputs[index]) {
        inputs[index].value = digit;
      }
    });

    // Mettre le focus sur le dernier champ
    if (inputs[inputs.length - 1]) {
      inputs[inputs.length - 1].focus();
    }

    // Mettre à jour la valeur cachée et l'état du bouton
    updateHiddenValue();
  }

  inputs.forEach((input, index) => {
    // Input: auto-focus next
    input.addEventListener('input', (e) => {
      const value = e.target.value;

      // Accepter seulement les chiffres (pour inputs type="number")
      if (value && !/^\d$/.test(value)) {
        e.target.value = '';
        return;
      }

      // Passer à la prochaine case
      if (value && index < inputs.length - 1) {
        inputs[index + 1].focus();
      }

      updateHiddenValue();
    });

    // Keydown: navigation
    input.addEventListener('keydown', (e) => {
      // Backspace: retourner à la case précédente
      if (e.key === 'Backspace' && !e.target.value && index > 0) {
        inputs[index - 1].focus();
      }

      // Flèches
      if (e.key === 'ArrowLeft' && index > 0) {
        inputs[index - 1].focus();
      }
      if (e.key === 'ArrowRight' && index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    });

    // Paste: distribuer les chiffres
    input.addEventListener('paste', (e) => {
      e.preventDefault();
      const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);

      pastedData.split('').forEach((char, i) => {
        if (inputs[i]) {
          inputs[i].value = char;
        }
      });

      if (pastedData.length > 0) {
        const lastIndex = Math.min(pastedData.length - 1, inputs.length - 1);
        inputs[lastIndex].focus();
      }

      updateHiddenValue();
    });
  });

  function updateHiddenValue() {
    const code = Array.from(inputs).map(input => input.value).join('');
    if (hiddenInput) {
      hiddenInput.value = code;
    }

    // Vérifier si tous les champs sont remplis pour activer/désactiver le bouton
    const allFilled = Array.from(inputs).every(input => input.value.length === 1);

    if (submitButton) {
      submitButton.disabled = !allFilled;
    }

    // Auto-submit si activé et tous les champs sont remplis
    if (autoSubmit && allFilled && form) {
      // Petit délai pour permettre à l'utilisateur de voir le dernier chiffre entré
      setTimeout(() => {
        form.requestSubmit();
      }, 300);
    }
  }
}
